module.exports = __webpack_public_path__ + "static/img/zjdbj.8111c52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zjdbj.jpg
// module id = hE6I
// module chunks = 46